"use client"

import styles from "./Appointment.module.css"

/**
 * Sol tarafta resim, sağ tarafta başlık ve metin paragraflar
 * 
 * @param {string} title - Başlık metni
 * @param {string[]} paragraphs - Paragraf dizisi
 * @param {string} image - Resim URL'i
 * @param {string} imageAlt - Resim için alternatif metin
 */
export default function Appointment({
  title,
  paragraphs = [],
  image,
  imageAlt = "Treatment Consultation"
}) {

  return (
    <section className={styles.section}>
      <div className={styles.container}>
        <div className={styles.contentWrapper}>
          {/* Sol Taraf - Resim */}
          <div className={styles.imageContainer}>
            <img 
              src={image} 
              alt={imageAlt}
              className={styles.image}
            />
          </div>

          {/* Sağ Taraf - Metin Bloğu */}
          <div className={styles.textBlock}>
            {/* Başlık */}
            <h2 className={styles.title}>{title}</h2>
            
            {/* İçerik - Paragraflar */}
            <div className={styles.content}>
              {paragraphs.map((paragraph, index) => (
                <p key={index} className={styles.paragraph}>{paragraph}</p>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
